import { useEffect as m } from "react";
import c from "classnames";
import { lazyLoadCSS as r } from "../utils/loader.js";
import { jsx as i } from "react/jsx-runtime";
function p({
  type: o,
  name: s,
  className: t
}) {
  return m(() => {
    r("https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css");
  }, []), /* @__PURE__ */ i("i", {
    className: c(`bx ${o}-${s}`, t),
    contentEditable: !1
  });
}
export {
  p as Icon
};
